import querystring from 'querystring';

const CACHE_PREFIX = 'cache_';

export function cacheQueryInDev(url, data) {
  return _cacheQueryInDev(url, data, localStorage, document.location.href);
}

function browserUrlHasCache(browserUrl) {
  browserUrl = browserUrl || '';
  let browserQuery = browserUrl.split('?')[1] || '';
  let q = querystring.parse(browserQuery);
  // it used to cache by parameter
  return q.cache == 1;
  // cache only in development
  // return PRODUCTION ? false : true;
}

export function _cacheQueryInDev(url, data, localStorage, browserUrl) {
  if (browserUrlHasCache(browserUrl)) {
    let key = CACHE_PREFIX + '_' + url + '_' + (typeof (data) === 'string' ? data : JSON.stringify(data));
    let d = localStorage[key];
    if (d) {
      return JSON.parse(d);
    }
  } else {
    _cacheQueryInDevClear(localStorage);
  }
  return null;
}

export function cacheQueryInDevSave(url, data, result) {
  return _cacheQueryInDevSave(url, data, result, localStorage, document.location.href);
}

export function _cacheQueryInDevSave(url, data, result, localStorage, browserUrl) {
  if (browserUrlHasCache(browserUrl)) {
    let key = CACHE_PREFIX + '_' + url + '_' + (typeof (data) === 'string' ? data : JSON.stringify(data));
    localStorage[key] = JSON.stringify(result);
  }
}

export function cacheQueryInDevClear() {
  return _cacheQueryInDevClear(localStorage);
}

export function _cacheQueryInDevClear(localStorage) {
  // iterate keys
  for (let i = localStorage.length - 1; i >= 0; i--) {
    let key = localStorage.key(i) || '';
    // remove cache nodes
    if (key.indexOf(CACHE_PREFIX) >= 0) {
      localStorage.removeItem(key);
    }
  }
}
